import React from 'react';
import {Dates} from '../utils';
import {subscribeToSeconds} from './clockSubscription';

// The wall clock is an external store, so it is read the way React reads one
// (see ./clockSubscription for why reading it in `getSnapshot` is sound).
// React compares snapshots with `Object.is`, which keeps the property the
// state-plus-effect version got from storing the formatted *string*: the
// screen re-renders when the text changes -- once a minute for the default
// `LLL` -- not once a second. Formatting during render rather than in an
// effect is what makes a timezone or formatter change show in that same
// render instead of a second pass.
const useCurrentTime = (timezone: string, formatter: string = 'LLL') =>
  React.useSyncExternalStore(subscribeToSeconds, () =>
    Dates.formatDate(Dates.now(), timezone, formatter),
  );

export default useCurrentTime;
